var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckedBuildActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#56A012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93508 11.685C7.78508 11.685 7.64258 11.625 7.53758 11.52L5.41508 9.39745C5.19758 9.17995 5.19758 8.81995 5.41508 8.60245C5.63258 8.38495 5.99258 8.38495 6.21008 8.60245L7.93508 10.3275L11.7901 6.47245C12.0076 6.25495 12.3676 6.25495 12.5851 6.47245C12.8026 6.68995 12.8026 7.04995 12.5851 7.26745L8.33258 11.52C8.22758 11.625 8.08508 11.685 7.93508 11.685Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckedBuildActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-checked-build-active.12712d07e101a1f18fdc247e888577fa.svg";